import {InterestRepository} from "../repository";
import {Interest} from "../../../domain/entities/entities";
import http from "../http";
import {wrapErrorHandler} from "../utils/wrap_error_handler";

class _Interest_repository implements InterestRepository {
  list(): Promise<Interest[]> {
    return wrapErrorHandler<Interest[]>(async () => {
      const response = await http
        .get("/api/decola/interest/list");
      return response.data.interests;
    });
  }

  relateInterestToUser(interests: Array<Interest>): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      await http
        .post("/api/decola/interest/link", { interests: interests });
    });
  }

  listUserInterest(): Promise<Interest[]> {
    return wrapErrorHandler<Interest[]>(async () => {
      const response = await http
        .get("/api/decola/list/interests/user");
      return response.data.interests;
    });
  }
}

export const interfaceInterestRepository: InterestRepository = new _Interest_repository();
